export class InvoiceProcessMode {
  public isDryRun: boolean = true;
  public invoiceWetRunMessage: string;
  public enableWetModeMsg: string;
  public batchWetRunMessage: string;
  public paymentWetRunMessage: string;
  public xeroBatchWetRunMessage: string;
  public systemInfo: { passPhrase: string; systemId: number };

  constructor() {
    this.invoiceWetRunMessage = 'Proceed with running LIVE invoice process?';
    this.enableWetModeMsg = 'Live run pass phrase';
    this.batchWetRunMessage = 'Proceed with running LIVE batch process?';
    this.paymentWetRunMessage = 'Proceed with running LIVE payment process?';
    this.xeroBatchWetRunMessage = 'Proceed with running Xero Batch Invoice process?';
    this.systemInfo = { passPhrase: null, systemId: null };
  }
}
